import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "svg",
  {
    width: "8",
    height: "10",
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "jm-min-w-2 jm-min-h-[10px]",
    children: /* @__PURE__ */ C(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.85355 0.00278971C2.49485 0.0766534 1.38892 1.04784 1.17228 2.35739C1.15257 2.4765 1.14429 2.65847 1.14424 2.97351L1.14416 3.42061L0.985299 3.49471C0.491679 3.72493 0.15881 4.12848 0.0331349 4.64903C0.00225161 4.77696 0 4.91463 0 6.67248C0 8.43034 0.00225161 8.56801 0.0331349 8.69593C0.112146 9.02317 0.252064 9.27184 0.490123 9.50813C0.706654 9.72303 0.987954 9.88177 1.29062 9.95986L1.44622 10H4H6.55378L6.70938 9.95986C6.79497 9.93777 6.93443 9.88742 7.01928 9.84795C7.5075 9.62084 7.84165 9.2146 7.96687 8.69593C7.99775 8.56801 8 8.43034 8 6.67248C8 4.91463 7.99775 4.77696 7.96687 4.64903C7.88785 4.3218 7.74794 4.07312 7.50988 3.83684C7.3626 3.69067 7.21249 3.58695 7.0147 3.49471L6.85584 3.42061L6.85574 2.97351C6.85565 2.61258 6.84875 2.48679 6.8199 2.3207C6.62988 1.22652 5.79165 0.346805 4.6865 0.0816717C4.44185 0.0229864 4.09186 -0.0101645 3.85355 0.00278971ZM3.72225 1.13719C3.15244 1.23538 2.69893 1.57083 2.45432 2.07505C2.31888 2.35419 2.28007 2.57396 2.27949 3.06471L2.27918 3.33607H4H5.72082L5.72051 3.06471C5.71993 2.57396 5.68112 2.35419 5.54568 2.07505C5.31714 1.60397 4.88168 1.26335 4.36892 1.15454C4.19083 1.11676 3.888 1.10863 3.72225 1.13719ZM3.16811 6.48589C3.23248 6.22049 3.46263 5.98339 3.73935 5.8974C3.882 5.85308 4.10967 5.8527 4.25463 5.89657C4.53582 5.98162 4.76679 6.21743 4.83189 6.48589C4.906 6.79153 4.82541 7.0717 4.60145 7.28706C4.2657 7.6099 3.7343 7.6099 3.39855 7.28706C3.17459 7.0717 3.09401 6.79153 3.16811 6.48589Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  l as LockIcon
};
//# sourceMappingURL=LockIcon.js.map
